import React from 'react';
import { motion } from 'framer-motion';
import PageHeader from '../components/PageHeader';

export default function Privacidad({ onBack }) {
  const sections = [
    {
      title: "1. Responsable del tratamiento",
      content: `Veritas Scan es un servicio web operado de forma independiente. Para cualquier consulta relacionada con la privacidad puedes contactarnos en:

• Email: privacy@veritas-scan.com
• Web: veritas-scan.com

Responderemos en un plazo máximo de 30 días hábiles.`
    },
    {
      title: "2. Datos que recogemos",
      content: `Veritas Scan recoge y trata los siguientes datos según cómo uses el servicio:

DATOS DE CUENTA (usuarios registrados)
• Nombre completo, dirección de correo electrónico y contraseña cifrada con bcrypt.
• Si te registras con Google OAuth: nombre, email e identificador de Google.
• Plan de suscripción activo (free, pro o business) y fechas de renovación.

DATOS DE PAGO
• Los datos de tarjeta son gestionados íntegramente por Stripe (PCI-DSS nivel 1). Veritas Scan únicamente almacena el identificador de cliente Stripe y el ID de suscripción, nunca los datos de tu tarjeta.

ARCHIVOS E IMÁGENES ANALIZADOS
• Los archivos que subes (imágenes JPG/PNG/GIF/WebP, vídeos MP4/MOV/AVI/WebM/MKV, documentos PDF/DOCX/TXT) se procesan para el análisis solicitado.
• Las imágenes se suben temporalmente a Cloudinary únicamente para ser procesadas por Gemini y por Google Cloud Vision SafeSearch. Se eliminan de Cloudinary tras el análisis.
• Los vídeos se envían a Gemini File API y se eliminan automáticamente una vez procesados.
• Ningún archivo se almacena de forma permanente ni se comparte con terceros para otros fines.

MODERACIÓN DE CONTENIDO
• Todas las imágenes pasan por Google Cloud Vision SafeSearch antes del análisis de IA para detectar y bloquear contenido explícito, violento o que infrinja nuestras normas de uso aceptable. Los resultados de moderación no se almacenan.

HISTORIAL DE ANÁLISIS
• Usuarios registrados: los resultados (veredicto, confianza, explicación, tipo de archivo, nombre) se guardan en MongoDB Atlas vinculados a tu cuenta. Accesibles desde cualquier dispositivo.
• Usuarios sin cuenta: el historial se guarda únicamente en el localStorage de tu navegador y nunca llega a nuestros servidores.

DATOS DE SESIÓN
• Registramos la dirección IP junto con el User-Agent (navegador y dispositivo) para calcular un identificador de dispositivo anónimo que controla el límite diario de 5 análisis gratuitos. Esto permite que cada dispositivo tenga su propia cuota independiente, incluso dentro de la misma red doméstica.
• La IP también se usa para mostrarte información de sesión en el panel de seguridad, con geolocalización aproximada (ciudad, región, país) e ISP obtenidos de ip-api.com.
• Los datos de dispositivo para límite diario se eliminan automáticamente cada 24 horas. Nunca se almacena el User-Agent de forma permanente.

API KEYS
• Los usuarios Pro y Business pueden generar API keys personales (formato vs_xxxx) para integrar el servicio. Las keys se almacenan cifradas asociadas a tu cuenta.`
    },
    {
      title: "3. Finalidad del tratamiento",
      content: `Los datos se usan exclusivamente para:

• Prestar el servicio de análisis de contenido (imágenes, vídeos, documentos, texto, URLs)
• Gestionar tu cuenta de usuario, autenticación y sesión
• Mostrar información de sesión activa (IP, ubicación aproximada, navegador, dispositivo) en el panel de seguridad
• Almacenar y sincronizar tu historial de análisis en la nube
• Procesar y gestionar suscripciones Pro y Business mediante Stripe
• Controlar el límite diario de 5 análisis por dispositivo en el plan gratuito
• Exportar informes en PDF/HTML para usuarios Pro y Business
• Gestionar análisis por lotes (hasta 10 archivos en Pro, hasta 50 en Business)
• Gestionar el acceso a la API pública mediante API keys personales
• Moderar contenido mediante Google Cloud Vision SafeSearch para prevenir el uso abusivo
• Procesar vídeos mediante Gemini File API para detección de deepfakes
• Enviar notificaciones importantes sobre cambios en el servicio (solo si tienes cuenta)
• Garantizar la seguridad y el correcto funcionamiento del servicio
• Detectar y prevenir usos abusivos o fraudulentos`
    },
    {
      title: "4. Base legal",
      content: `El tratamiento de los datos se basa en:

• Consentimiento: al crear una cuenta y aceptar estos términos.
• Ejecución del contrato: para prestar el servicio de suscripción Pro o Business.
• Interés legítimo: para garantizar la seguridad del servicio, controlar el uso abusivo y moderar el contenido inapropiado.
• Obligación legal: para conservar datos de facturación según la normativa fiscal aplicable.

Todo ello de conformidad con el Reglamento General de Protección de Datos (RGPD) y la Ley Orgánica 3/2018 de Protección de Datos Personales (LOPDGDD).`
    },
    {
      title: "5. Terceros y transferencias de datos",
      content: `Veritas Scan utiliza los siguientes servicios de terceros:

• Stripe (stripe.com/privacy): procesamiento seguro de pagos y suscripciones. Tus datos de pago se rigen por su política PCI-DSS.
• Google OAuth (policies.google.com/privacy): si inicias sesión con Google, Google comparte tu nombre y email con nosotros.
• Google Gemini — Google DeepMind (ai.google.dev): modelo de IA que procesa el contenido analizado. Los archivos se envían exclusivamente para el análisis y se eliminan automáticamente.
• Google Cloud Vision SafeSearch (cloud.google.com/vision): moderación automática de imágenes para detectar contenido inapropiado antes del análisis de IA.
• Cloudinary (cloudinary.com/privacy): almacenamiento temporal de imágenes para procesarlas con Gemini y Vision. Las imágenes se eliminan tras el análisis.
• ip-api.com: geolocalización aproximada de la IP del usuario para mostrar información de sesión en el panel de seguridad. No se almacenan datos de localización.
• MongoDB Atlas — MongoDB, Inc. (mongodb.com/legal/privacy-policy): base de datos en la nube donde se almacenan datos de cuenta, historial y suscripciones. Cifrado en tránsito y en reposo.
• Railway (railway.app): proveedor de infraestructura donde se ejecuta el backend.
• Vercel (vercel.com/legal/privacy-policy): alojamiento del frontend.

No vendemos ni cedemos tus datos personales a terceros con fines publicitarios o comerciales.`
    },
    {
      title: "6. Conservación de datos",
      content: `• Datos de cuenta: mientras la cuenta esté activa. Puedes solicitar la eliminación en cualquier momento desde el panel de Cuenta → Eliminar cuenta.
• Historial de análisis en la nube: mientras la cuenta esté activa. Puedes eliminarlo en cualquier momento desde la aplicación.
• Archivos e imágenes analizadas: se eliminan de Cloudinary y de nuestros servidores inmediatamente tras el análisis. Los vídeos en Gemini File API se eliminan automáticamente.
• Identificador de dispositivo (hash IP+User-Agent) para límite diario: 24 horas, eliminación automática.
• Datos de sesión (User-Agent): no se persisten; se usan en tiempo real para mostrarte la información de sesión y calcular el identificador de dispositivo.
• Datos de suscripción y facturación: durante el período legalmente exigido tras la cancelación (mínimo 4 años según normativa fiscal española).
• API keys: mientras la cuenta tenga plan Pro o Business activo. Se revocan automáticamente al cancelar la suscripción o eliminar la cuenta.`
    },
    {
      title: "7. Tus derechos (RGPD)",
      content: `De acuerdo con el RGPD tienes derecho a:

• Acceso: conocer qué datos tenemos sobre ti.
• Rectificación: corregir tu nombre desde el panel de Perfil.
• Supresión: eliminar tu cuenta y todos los datos asociados desde el panel de Cuenta → Eliminar cuenta, o solicitándolo por email.
• Limitación: restringir el tratamiento en casos específicos.
• Portabilidad: recibir tus datos en formato estructurado (JSON). Disponible en el panel de Cuenta → Exportar datos.
• Oposición: oponerte al tratamiento basado en interés legítimo.
• Retirar el consentimiento: en cualquier momento, sin que ello afecte a la licitud del tratamiento previo.

Para ejercer estos derechos: privacy@veritas-scan.com. Responderemos en 30 días hábiles.
También puedes presentar una reclamación ante la Agencia Española de Protección de Datos (aepd.es).`
    },
    {
      title: "8. Seguridad técnica",
      content: `Medidas de seguridad implementadas:

• Contraseñas cifradas con bcrypt (coste 12).
• Comunicaciones HTTPS con TLS en todo el tráfico.
• Autenticación mediante tokens JWT con caducidad.
• Datos de pago gestionados por Stripe bajo PCI-DSS nivel 1.
• Base de datos MongoDB Atlas con cifrado en tránsito y en reposo.
• Imágenes temporales en Cloudinary con eliminación automática post-análisis.
• Moderación de imágenes con Google Cloud Vision SafeSearch para bloquear contenido ilegal.
• API keys almacenadas cifradas, con prefijo vs_ para identificación.
• Acceso al historial en la nube restringido al usuario autenticado mediante JWT.`
    },
    {
      title: "9. Menores de edad",
      content: "Veritas Scan no está dirigido a menores de 14 años. Si eres menor de 14 años, no debes crear una cuenta ni utilizar este servicio sin el consentimiento expreso de tus padres o tutores legales. Si detectamos que un menor ha creado una cuenta sin autorización, la eliminaremos de inmediato."
    },
    {
      title: "10. Transferencias internacionales",
      content: "Algunos de nuestros proveedores (Google, MongoDB Atlas, Cloudinary, Stripe, Vercel, Railway) pueden procesar datos en servidores ubicados fuera del Espacio Económico Europeo. Todas estas transferencias se realizan al amparo de las garantías adecuadas previstas en el RGPD (cláusulas contractuales tipo, decisiones de adecuación o marcos de protección equivalentes)."
    },
    {
      title: "11. Cambios en la política",
      content: "Nos reservamos el derecho a modificar esta política. Los cambios se publicarán en esta página con la fecha de actualización. Si los cambios son sustanciales y tienes una cuenta registrada, te notificaremos por correo electrónico con al menos 15 días de antelación."
    }
  ];

  return (
    <div className="min-h-screen bg-zinc-950 relative">
      <div className="scanlines" />
      <div className="fixed inset-0 pointer-events-none" style={{ background: 'radial-gradient(circle at 50% 0%, rgba(59, 130, 246, 0.08), transparent 60%)' }} />

      <PageHeader onBack={onBack} />

      <main className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 py-10 sm:py-16">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="space-y-6 sm:space-y-8">

          <div className="space-y-2">
            <p className="font-mono text-xs tracking-widest text-blue-500 uppercase">Legal</p>
            <h1 className="font-heading text-3xl sm:text-4xl font-black">Política de Privacidad</h1>
            <p className="text-zinc-500 font-mono text-sm">Última actualización: marzo 2026</p>
          </div>

          <div className="bg-blue-500/10 border border-blue-500/25 rounded-xl p-4 text-blue-300 font-mono text-xs leading-relaxed">
            Resumen: No vendemos tus datos. Los archivos que analizas se eliminan tras el análisis. Solo guardamos lo necesario para prestarte el servicio. Puedes eliminar tu cuenta y todos tus datos en cualquier momento.
          </div>

          {sections.map(({ title, content }) => (
            <div key={title} className="bg-zinc-900 border border-zinc-800 rounded-xl p-5 sm:p-6 space-y-3">
              <h2 className="font-heading text-base sm:text-lg font-bold text-white">{title}</h2>
              <p className="text-zinc-400 leading-relaxed whitespace-pre-line text-sm">{content}</p>
            </div>
          ))}

        </motion.div>
      </main>
    </div>
  );
}
